// extracted by mini-css-extract-plugin
export default {"card-browser-slider":"card-browser-slider","slider":"slider","icon-container-left":"icon-container-left","icon-container-right":"icon-container-right"};